<template>
  <div>
    <v-container>
      <v-expansion-panels xpansion-panels multiple v-model="panel">
        <v-expansion-panel v-if="reportType != 'headCount'">
          <v-expansion-panel-header
            >List of Employees Per</v-expansion-panel-header
          >
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
                <v-autocomplete
                  :items="groupByItems"
                  item-text="text"
                  item-value="value"
                  return-object
                  v-model="groupByData"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="groupByData.value == 'BankAccountType'">
              <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
                <v-radio-group row v-model="groupByDataFilter">
                  <v-radio label="All" value="SA,CA"></v-radio>
                  <v-radio label="SA" value="SA"></v-radio>
                  <v-radio label="CA" value="CA"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <province-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'Address'"
              v-model="groupByDataFilter"
            ></province-selection>

            <area-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'AreaDesc'"
              v-model="groupByDataFilter"
            ></area-selection>

            <blood-type-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'BloodType'"
              v-model="groupByDataFilter"
            ></blood-type-selection>

            <branch-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'BraDesc'"
              v-model="groupByDataFilter"
            ></branch-selection>

            <citizenship-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'Citizenship'"
              v-model="groupByDataFilter"
            ></citizenship-selection>

            <civil-status-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'CivilStatus'"
              v-model="groupByDataFilter"
            ></civil-status-selection>

            <course-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'CourseDesc'"
              v-model="groupByDataFilter"
            ></course-selection>

            <designation-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'Designation'"
              v-model="groupByDataFilter"
            ></designation-selection>

            <educ-attainment-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'EduAttDesc'"
              v-model="groupByDataFilter"
            ></educ-attainment-selection>

            <emp-status-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'EmpStatDesc'"
              v-model="groupByDataFilter"
            ></emp-status-selection>

            <v-row v-if="groupByData.value == 'Sex'">
              <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
                <v-radio-group row v-model="groupByDataFilter">
                  <v-radio label="All" value="2"></v-radio>
                  <v-radio label="Male" value="1"></v-radio>
                  <v-radio label="Female" value="0"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <group-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'Group'"
              v-model="groupByDataFilter"
            ></group-selection>

            <job-level-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'JobLevelDesc'"
              v-model="groupByDataFilter"
            ></job-level-selection>

            <major-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'MajorDesc'"
              v-model="groupByDataFilter"
            ></major-selection>

            <location-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'LocationDesc'"
              v-model="groupByDataFilter"
            ></location-selection>

            <movement-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'MovementTypeDesc'"
              v-model="groupByDataFilter"
            ></movement-selection>

            <movement-details-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'ReasonDesc'"
              v-model="groupByDataFilter"
            ></movement-details-selection>

            <pagibig-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'PagibigDesc'"
              v-model="groupByDataFilter"
            ></pagibig-selection>

            <pay-loc-selection
              :show-dense="false"
              :headers="payLocHeaders"
              :show-select="true"
              v-if="groupByData.value == 'PayLoc'"
              v-model="groupByDataFilter"
            ></pay-loc-selection>

            <pay-house-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'PayHouse'"
              v-model="groupByDataFilter"
            ></pay-house-selection>

            <pay-type-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'PayType'"
              v-model="groupByDataFilter"
            ></pay-type-selection>

            <province-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'Province'"
              v-model="groupByDataFilter"
            ></province-selection>

            <religion-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'Religion'"
              v-model="groupByDataFilter"
            ></religion-selection>

            <school-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'SchoolDesc'"
              v-model="groupByDataFilter"
            ></school-selection>

            <section-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'Section'"
              v-model="groupByDataFilter"
            ></section-selection>

            <skills-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'Skills'"
              v-model="groupByDataFilter"
            ></skills-selection>

            <tax-status-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'TaxStatus'"
              v-model="groupByDataFilter"
            ></tax-status-selection>

            <v-row v-if="groupByData.value == 'District'">
              <v-col cols="12" md="12" sm="12" xs="12" :class="classPadding">
                <v-radio-group row v-model="district">
                  <v-radio label="Present" value="Present"></v-radio>
                  <v-radio label="Permanent" value="Permanent"></v-radio>
                  <v-radio label="Provincial" value="Provincial"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <district-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'District'"
              v-model="groupByDataFilter"
            ></district-selection>

            <salary-class-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'SalaryClass'"
              v-model="groupByDataFilter"
            ></salary-class-selection>

            <emp-cat-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'EmpCat'"
              v-model="groupByDataFilter"
            ></emp-cat-selection>

            <rank-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'Rank'"
              v-model="groupByDataFilter"
            ></rank-selection>

            <unit-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'Unit'"
              v-model="groupByDataFilter"
            ></unit-selection>

            <pay-loc-selection
              :show-dense="false"
              :headers="payLocHeaders"
              :show-select="true"
              v-if="groupByData.value == 'TKGroup'"
              v-model="groupByDataFilter"
            ></pay-loc-selection>

            <region-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'Region'"
              v-model="groupByDataFilter"
            ></region-selection>

             <online-app-selection
              :show-dense="false"
              :show-select="true"
              v-if="groupByData.value == 'OnlineApp'"
              v-model="groupByDataFilter"
            ></online-app-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Date Range</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
                <custom-datepicker
                  :class-padding="classPadding"
                  label="Date From"
                  v-model="dateFrom"
                ></custom-datepicker>
              </v-col>
              <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
                <custom-datepicker
                  :class-padding="classPadding"
                  label="Date To"
                  v-model="dateTo"
                ></custom-datepicker>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Payroll Location</v-expansion-panel-header>
          <v-expansion-panel-content>
            <pay-loc-selection
              :show-dense="false"
              :headers="payLocHeaders"
              :show-select="true"
              v-model="payLoc"
              :by-user="true"
            ></pay-loc-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Department</v-expansion-panel-header>
          <v-expansion-panel-content>
            <department-selection
              :show-dense="false"
              :show-select="true"
              v-model="department"
            ></department-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Division</v-expansion-panel-header>
          <v-expansion-panel-content>
            <division-selection
              :show-dense="false"
              :show-select="true"
              v-model="division"
            ></division-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Branch</v-expansion-panel-header>
          <v-expansion-panel-content>
            <branch-selection
              :show-dense="false"
              :show-select="true"
              v-model="branch"
            ></branch-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Section</v-expansion-panel-header>
          <v-expansion-panel-content>
            <section-selection
              :show-dense="false"
              :show-select="true"
              v-model="section"
            ></section-selection>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>Status</v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-radio-group row v-model="group" :class="classPadding">
              <v-radio label="All" value="2"></v-radio>
              <v-radio :label="'Active'" value="1"></v-radio>
              <v-radio :label="'Inactive'" value="0"></v-radio>
            </v-radio-group>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-row v-if="groupByData.value == 'Sex'">
        <v-col cols="12" md="4" sm="6" xs="12" :class="classPadding">
          <span>Report Template</span>
          <v-radio-group row v-model="group2">
            <v-radio label="Standard Format" value="0"></v-radio>
            <v-radio label="Professional Format" value="1"></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="12">
          <v-btn
            outlined
            @click.stop="exportReport"
            :loading="loading"
            :class="classPadding"
            >Export</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import moment from "moment";
const CustomDatepicker = () => import("../../../components/CustomDatepicker");
const PayLocSelection = () =>
  import("../../setup/general/payroll-location/NewSelection");

const DepartmentSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/department/NewSelection"
  );
const PayHouseSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/pay-house/NewSelection"
  );
const DivisionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/division/NewSelection"
  );
const BranchSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/branch/NewSelection"
  );

const SectionSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/section/NewSelection"
  );

const AreaSelection = () =>
  import("../../setup/employment-info/organizational-level/area/NewSelection");

const JobLevelSelection = () =>
  import("../../setup/employment-info/employee-level/job-level/NewSelection");

const EmpStatusSelection = () =>
  import(
    "../../setup/employment-info/employee-level/employee-status/NewSelection"
  );

const BloodTypeSelection = () => import("../../others/BloodTypeSelection");

const CitizenshipSelection = () =>
  import("../../setup/personal-information/citizenship/NewSelection");

const CivilStatusSelection = () => import("../../others/CivilStatusSelection");

const DistrictSelection = () => import("../../others/DistrictSelection");

const CourseSelection = () =>
  import("../../setup/employment-other-info/education/course/NewSelection");

const DesignationSelection = () =>
  import("../../setup/employment-info/employee-level/designation/NewSelection");

const EducAttainmentSelection = () =>
  import(
    "../../setup/employment-other-info/education/educ-attainment/NewSelection"
  );

const GroupSelection = () =>
  import("../../setup/employment-info/organizational-level/group/NewSelection");

const LocationSelection = () =>
  import(
    "../../setup/employment-info/organizational-level/location/NewSelection"
  );

const MajorSelectioon = () =>
  import("../../setup/employment-other-info/education/major/NewSelection");

const MovementSelection = () =>
  import("../../setup/general/movement-type/Selection");

const MovementDetailsSelection = () =>
  import("../../setup/general/movement-type-details/Selection");

const PagibigSelection = () =>
  import("../../setup/general/pagbig-file/NewSelection");

const PayTypeSelection = () => import("../../others/PayTypeSelection");

const ReligionSelection = () =>
  import("../../setup/personal-information/religion/NewSelection");

const SchoolSelection = () =>
  import("../../setup/employment-other-info/education/school/NewSelection");

const TaxStatusSelection = () =>
  import("../../setup/general/tax-status/NewSelection");

const UnitSelection = () =>
  import("../../setup/employment-info/organizational-level/unit/NewSelection");

const ProvinceSelection = () =>
  import("../../setup/personal-information/province/NewSelection");

const MajorSelection = () =>
  import("../../setup/employment-other-info/education/major/NewSelection");

const SkillsSelection = () =>
  import("../../setup/employment-other-info/others/skills/NewSelection");
const SalaryClassSelection = () =>
  import(
    "../../setup/employment-info/employee-level/salary-classification/NewSelection"
  );

const EmpCatSelection = () =>
  import(
    "../../setup/employment-info/employee-level/employee-category/NewSelection"
  );

const RankSelection = () =>
  import("../../setup/employment-info/employee-level/rank/NewSelection");

const RegionSelection = () =>
  import("../../setup/personal-information/region/NewSelection");
const OnlineAppSelection = () =>
  import("../../setup/employment-other-info/others/online-app/NewSelection");

const API_ENDPOINT = "/api/reports";
export default {
  data: () => ({
    title: "Purge Employee Masterfile",
    classPadding: "my-0 py-0",
    dateFrom: null,
    dateTo: null,
    payLocHeaders: [
      {
        text: "Loc Id",
        align: "left",
        //sortable: false,
        value: "locId",
      },
      {
        text: "Location Name",
        align: "left",
        //sortable: false,
        value: "locName",
      },
    ],
    payLoc: [],
    department: [],
    division: [],
    branch: [],
    section: [],
    areas: [],
    jobLevel: [],
    empStatus: [],
    isSearching: false,
    employees: [],
    headers: [
      {
        text: "Code",
        value: "empCode",
        sortable: false,
      },
      {
        text: "Last Name",
        value: "lName",
        sortable: false,
      },
      {
        text: "First Name",
        value: "fName",
        sortable: false,
      },
      {
        text: "Middle Name",
        value: "mName",
        sortable: false,
      },
    ],
    loading: false,
    group: "2",
    group2: "0",
    panel: [7],
    selectedEmployees: [],
    mtd: [],
    reportType: "emp",
    groupByItems: [
      {
        text: "",
        value: "",
      },
      {
        text: "Account Type",
        value: "BankAccountType",
      },
      {
        text: "Address",
        value: "Address",
      },
      {
        text: "Area",
        value: "AreaDesc",
      },
      {
        text: "Blood Type",
        value: "BloodType",
      },
      {
        text: "Branch",
        value: "BraDesc",
      },
      {
        text: "Citizenship",
        value: "Citizenship",
      },
      {
        text: "Civil Status",
        value: "CivilStatus",
      },
      {
        text: "Degree/Course",
        value: "CourseDesc",
      },
      {
        text: "Department",
        value: "DepDesc",
      },
      {
        text: "Designation",
        value: "Designation",
      },
      {
        text: "Educational Attainment",
        value: "EduAttDesc",
      },
      {
        text: "Employee Status",
        value: "EmpStatDesc",
      },
      {
        text: "Gender",
        value: "Sex",
      },
      {
        text: "Hiring Date",
        value: "HiringDate",
      },
      {
        text: "Job Level",
        value: "JobLevelDesc",
      },
      {
        text: "Major",
        value: "MajorDesc",
      },
      {
        text: "Pag-Ibig",
        value: "PagibigDesc",
      },
      {
        text: "Pay Location",
        value: "PayLoc",
      },
      {
        text: "Pay Type",
        value: "PayType",
      },
      {
        text: "Province",
        value: "Province",
      },
      {
        text: "Religion",
        value: "Religion",
      },
      {
        text: "School",
        value: "SchoolDesc",
      },
      {
        text: "Section",
        value: "Section",
      },
      {
        text: "Skills",
        value: "Skills",
      },
      {
        text: "Tax Status",
        value: "TaxStatus",
      },
      {
        text: "District",
        value: "District",
      },
      {
        text: "Salary Classification",
        value: "SalaryClass",
      },
      {
        text: "Employee Category",
        value: "EmpCat",
      },
      {
        text: "Rank",
        value: "Rank",
      },
      {
        text: "Pay House",
        value: "PayHouse",
      },
      {
        text: "Unit",
        value: "Unit",
      },
      {
        text: "Group",
        value: "Group",
      },
      {
        text: "Timekeep Group",
        value: "TKGroup",
      },
      {
        text: "Region",
        value: "Region",
      },
      {
        text: "Online Approval Code",
        value: "OnlineApp",
      },
    ],
    groupBy: "",
    groupByData: {},
    groupByDataFilter: null,
    district: "Present",
  }),
  components: {
    CustomDatepicker,
    PayLocSelection,
    DepartmentSelection,
    DivisionSelection,
    BranchSelection,
    SectionSelection,
    AreaSelection,
    JobLevelSelection,
    EmpStatusSelection,
    BloodTypeSelection,
    CitizenshipSelection,
    CivilStatusSelection,
    CourseSelection,
    DesignationSelection,
    EducAttainmentSelection,
    GroupSelection,
    LocationSelection,
    MajorSelectioon,
    MovementSelection,
    MovementDetailsSelection,
    PagibigSelection,
    PayTypeSelection,
    ReligionSelection,
    SchoolSelection,
    TaxStatusSelection,
    UnitSelection,
    PayHouseSelection,
    ProvinceSelection,
    MajorSelection,
    SkillsSelection,
    SalaryClassSelection,
    EmpCatSelection,
    RankSelection,
    DistrictSelection,
    RegionSelection,
    OnlineAppSelection
  },
  computed: {
    grp() {
      return this.payLoc.join(", ");
    },
    dep() {
      return this.department.join(", ");
    },
    div() {
      return this.division.join(", ");
    },
    bra() {
      return this.branch.join(", ");
    },
    sec() {
      return this.section.join(", ");
    },
    area() {
      return this.areas.join(", ");
    },
    jl() {
      return this.jobLevel.join(", ");
    },
    empStat() {
      return this.empStatus.join(", ");
    },
    groupByDataFilterComputed() {
      if (this.groupByDataFilter === null) {
        return "";
      } else if (typeof this.groupByDataFilter === "object") {
        return this.groupByDataFilter.join(", ");
      } else if (this.groupByDataFilter === 0) {
        return "";
      } else {
        return this.groupByDataFilter;
      }
    },
  },
  methods: {
    reset() {
      this.dateFrom = null;
      this.dateTo = null;
      this.payLoc = [];
      this.department = [];
      this.division = [];
      this.branch = [];
      this.section = [];
    },
    exportReport() {
      this.loading = true;
      var data = {
        Grp: this.grp,
        Dep: this.dep,
        Bra: this.bra,
        Div: this.div,
        Sec: this.sec,
        Stat: this.group,
        DateFrom: moment(this.dateFrom).format("MM/DD/YYYY"),
        DateTo: moment(this.dateTo).format("MM/DD/YYYY"),
        GrpColData: this.groupByDataFilterComputed,
        GrpColumn: this.groupByData.value,
        District: this.district,
        Format: this.group2
      };

      this.$axios
        .post(`${API_ENDPOINT}/list-emp-per-fields`, data)
        .then(({ data }) => {
          var subPath = process.env.VUE_APP_PATH;
          if (this.groupBy != "") {
            window.open(`${subPath.slice(0, -1)}${url}/${data}`);
          } else {
            window.open(
              `${subPath.slice(0, -1)}/report-viewer?reportCode=${
                data.reportCode
              }&dbName=${data.dbName}&key=${data.key}&companyKey=${
                data.companyKey
              }&reportUrl=${data.url}&client=${data.client}&logoAlign=${
                data.logoAlign
              }&logoWidth=${data.logoWidth}&rpt=${data.rpt}`
            );
          }
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    groupByData(newVal, oldVal) {
      if (newVal.value !== oldVal.value) {
        this.groupByDataFilter = null;
      }
    },
  },
};
</script>
